import { Subscribe } from '@react-rxjs/core'
import React, { useEffect } from 'react'

import {
  latestCartItemProduct$,
  setCartItemSku,
  useCartItemProduct,
} from '../../../lib/cart/state/cart-items/cart-item-product'
import useSanityImage from '../../../lib/sanity/hooks/useSanityImage'
import ItemImage from './ItemImage'

interface CartItemImageProps {
  sku: string | undefined | null
  label: string | undefined
  icon?: React.ReactNode
  variant?: 'default' | 'small'
}
const CartItemImageContent: React.FC<CartItemImageProps> = ({ sku, label, icon, variant }) => {
  const image = useCartItemProduct(sku ?? '').mainImage
  const sanityImageUrl = useSanityImage(
    { sourceJson: image?.json },
    {
      dpr: 3,
      fit: 'max',
      // set width only to avoid crop bug: https://github.com/sanity-io/image-url/issues/32
      width: 70,
    },
  )

  return (
    <ItemImage
      image={{
        label,
        url: sanityImageUrl || '',
      }}
      variant={variant}
      icon={icon}
    />
  )
}

const CartItemImage: React.FC<CartItemImageProps> = ({ sku, label, icon, variant }) => {
  useEffect(() => {
    setCartItemSku(sku ?? '')
  }, [sku])

  return (
    <Subscribe source$={latestCartItemProduct$(sku ?? '')} fallback={null}>
      <CartItemImageContent sku={sku} label={label || undefined} icon={icon} variant={variant} />
    </Subscribe>
  )
}

export default CartItemImage
